import {
  DateRange,
  DayPickerProps,
  Matcher,
  Modifiers,
} from "react-day-picker";

export type DatePickerSelection = Date | Date[] | DateRange | undefined;

export type DatePickerSelectionEvent = {
  selected: DateRange | Date | Date[] | undefined;
  triggerDate: Date;
  modifiers: Modifiers;
  e: React.MouseEvent | React.KeyboardEvent;
  isRangeComplete?: boolean;
};

export enum DatePickerMode {
  single = "single",
  multiple = "multiple",
  range = "range",
}

export type DatePickerProps = Omit<DayPickerProps, "selected" | "required"> & {
  selected?: Date | Date[] | DateRange | undefined;
  onChangeSelected?: (event: DatePickerSelectionEvent) => void;
  required?: boolean;
  disableFutureDates?: boolean;
  disablePastDates?: boolean;
  customMatcher?: Matcher;
};

export const BASE_SELECTION_EVENT: DatePickerSelectionEvent = {
  selected: undefined,
  triggerDate: new Date(),
  modifiers: {},
  e: {} as React.MouseEvent | React.KeyboardEvent,
};
